import GenericComposedChart from "../../GenericCharts/BarCharts/GenericComposedChart";
import RechartLegend, {
  LEGEND_HEIGHT_PX,
  LEGEND_PADDING_PX,
} from "../../RechartHelpers/RechartLegend";
import CardWrapper from "../../CardWrapperStyles";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { MetricEnum } from "reports/utils/metricTypes";

export type StackedPnlBarChartDataType = {
  date: string;
  producing: number;
  planned: number;
  waiting: number;
  unplanned: number;
  unknown: number;
  notScheduled: number;
  metric: number;
};

export const StackedPnLBarChartStyles = styled.div`
  display: flex;
  justify-content: center;

  .metric {
    font-size: 12px;
    font-weight: bold;
    margin-top: ${LEGEND_HEIGHT_PX + 1.5 * LEGEND_PADDING_PX}px;
  }
`;

export default function StackedPnLBarChart({
  chartData,
  customBars,
  tooltipContent,
  xLabel = "",
  yLabel = "",
  width,
  height,
  metricTitle = MetricEnum.OEE,
  yAxisDomain,
  shouldWrapInCard = true,
  title = "Performance Chart",
  referenceLines,
}: {
  chartData: StackedPnlBarChartDataType[];
  customBars: any;
  tooltipContent: any;
  xLabel?: string;
  yLabel?: string;
  width: number;
  height: number;
  metricTitle?: string;
  yAxisDomain?: number[];
  shouldWrapInCard?: boolean;
  title?: string;
  referenceLines?: any[];
}) {
  const { t } = useTranslation("EOSReport");

  const StackedChartContent = () => (
    <>
      <div className="header">{t(title)}</div>
      <StackedPnLBarChartStyles>
        <div className="metric">{t(metricTitle)}</div>
        <GenericComposedChart
          data={chartData}
          {...{ customBars, width, tooltipContent }}
          xLabel={xLabel}
          yLabel={yLabel}
          height={height}
          legend={RechartLegend({ width })}
          yAxisDomain={yAxisDomain}
          referencelines={referenceLines}
        />
      </StackedPnLBarChartStyles>
    </>
  );

  return shouldWrapInCard ? (
    <CardWrapper>
      <StackedChartContent />
    </CardWrapper>
  ) : (
    <StackedChartContent />
  );
}
